export function useFormatters() {
  function formatCurrency(value: number, currency = 'ZAR'): string {
    if (!Number.isFinite(value)) return '—'
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  }

  function formatPercent(value: number, decimals = 2): string {
    if (!Number.isFinite(value)) return '—'
    return `${(value * 100).toFixed(decimals)}%`
  }

  function formatNumber(value: number, decimals = 0): string {
    if (!Number.isFinite(value)) return '—'
    return new Intl.NumberFormat('en-ZA', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value)
  }

  function parseMoney(input: string | number): number {
    if (typeof input === 'number') return input
    const cleaned = input
      .replace(/[^\d.,-]/g, '')
      .replace(/,/g, '')
      .replace(/\s/g, '')
    const parsed = Number(cleaned)
    return Number.isNaN(parsed) ? NaN : parsed
  }

  return { formatCurrency, formatPercent, formatNumber, parseMoney }
}
